import request from '@/utils/request'

export function buyList(params) {
    return request({
        url: '/video-pay/bill/buy/list',
        method: 'post',
        params
    })
}
export function getUser(params) {
    return request({
        url: '/video-pay/bill/user/info',
        method: 'post',
        params
    })
}